




























































import Component, { mixins } from "vue-class-component";
import MyMixin from "@/mixins/datemixin";
import { Rapport, RapportFav, TypeRapport } from "@/shared/Rapport";
import { Groupe } from "@/shared/Groupe";
import { Site } from "@/shared/Site";
import PdfViewer from "@/components/pdf-viewer.vue";
import RapportSelection from "@/components/rapportSelection.vue";
import MobileMixin from "@/mixins/mobileMixin";
import OneFavoris from "@/components/OneFavoris.vue";
import PdfReport from "@/shared/pdfReport";
import RapportMixin from "@/mixins/rapportMixin";
import HomeCharts from "@/home/HomeCharts.vue";
import { uuid } from "vue-uuid";

@Component({
  components: {
    PdfViewer,
    RapportSelection,
    OneFavoris,
    HomeCharts,
    /* DateChooser */
  },
})
export default class Home extends mixins(MyMixin, MobileMixin, RapportMixin) {
  public showRep = false;
  public edit = false;
  public favorisSelected: RapportFav = new RapportFav();
  public editFavs: boolean = false;
  public pdfReport: PdfReport = new PdfReport();
  public rapport: Rapport = new Rapport();
  public isLoading = true;

  // public dateType: DateType;

  public loaded() {
    this.isLoading = false;
  }

  /**
   * methode de generation d'un rapport favoris
   * transformation en rapport
   */
  public makeMyReport(rapport: RapportFav) {
    if (rapport !== undefined) {
      if (this.favorisSelected.id === rapport.id) {
        this.favorisSelected = new RapportFav();
        return;
      }
      this.$store.dispatch("login/setLoading", true);
      if (rapport.lSites.length === 0) {
        rapport.lSites = this.sites;
      }
      this.monrapport = new Rapport();
      const dates = this.checkPeriode(rapport.periode, rapport.typePeriode);
      this.monrapport.setDateDebut(dates.start);
      this.monrapport.setDateFin(dates.end);
      this.monrapport.fromRapportFav(rapport);
      if (rapport.typeSite === "groupe") {
        if (rapport.groupement && rapport.groupement.length > 0) {
          const idToFind = rapport.groupement[0].id;
          const gr = this.groupes.find(
            (groupe: Groupe) => groupe.id === idToFind
          );
          rapport.lSites = new Array();
          if (gr && gr.raisonsSociales !== undefined) {
            for (const rs of gr.raisonsSociales) {
              rapport.lSites.push(new Site(rs));
            }
          }
        }
      }
      this.$store.dispatch("rapport/updateRapport", this.monrapport);
      if (this.isMobile() || this.isElectron()) {
        this.makeReportMobile();
      } else {
        this.makeReport();
      }
    }
  }

  public activateEdition() {
    this.editFavs = !this.editFavs;
  }

  public addAFav() {
    // console.log(this.rapportFav)
    this.newFav();
  }

  public rapportSelected(rapport: TypeRapport) {
    this.newFav(rapport);
  }

  public newFav(typeRap?: TypeRapport) {
    if (this.favoris === undefined) {
      this.favoris = new Array();
    }
    const id = uuid.v4();
    const monFav: RapportFav = new RapportFav();
    monFav.id = id;

    if (typeRap) {
      monFav.typeRapport = typeRap;
    }
    this.$store.dispatch("rapport/updateNewFavoris", monFav).then((_: any) => {
      this.$router.push("/configFavoris");
    });
  }

  public isEditing(fav: any) {
    // console.log("bonjour ", fav.id);
    const res = fav.id === this.favorisSelected.id;
    // console.log("isEditing " + res);
    return res;
  }

  public hide(target: any) {
    this.$store.dispatch("rapport/updateRapport", new Rapport());
    this.showRep = false;
  }

  public cancelHold() {
    this.favorisSelected = new RapportFav();
  }

  public handleHold(param: any) {
    // console.log("handle");
    return (direction: string, event: any) => {
      // console.log(param, direction);
      this.favorisSelected = param;
      if (event.srcElement.id === "") {
        this.favorisSelected = this.favoris.filter(
          (fav: RapportFav) => fav.id === event.srcElement.parentNode.id
        );
      }
      this.edit = true;
    };
  }

  // computed
  get favoris(): any {
    return this.$store.getters["rapport/favoris"];
  }
  set favoris(newFav) {
    this.$store.dispatch("rapport/updateFavoris", this.favoris);
  }

  get rapportFav(): RapportFav {
    const fav = this.$store.getters["rapport/selectedFavoris"];
    return fav;
  }

  get groupes(): Groupe[] {
    return this.$store.getters["login/groupements"];
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
